import styled from "styled-components";

export const ProductCartContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 90%;
  align-items: center;
  position: relative;
  background-color: #4b484d;
  border-radius: 7px 7px 7px 7px;

  img {
    padding: 4px;
    width: 100%;
    height: 85%;
    object-fit: cover;
    margin-bottom: 5px;
    border-radius: 7px 7px 7px 7px;
    opacity: 1 !important;
  }

  button {
    width: 30%;
    opacity: 0.7;

    position: absolute;
    top: 255px;
    display: none;
    border-radius: 7px 7px 7px 7px;
  }

  &:hover {
    img {
      opacity: 0.8;
    }

    button {
      opacity: 0.85;
      display: flex;

      @media only screen and (max-width: 760px) {
        opacity: 0;
      }
    }
  }
`;

export const ImgBox = styled.img`
  cursor: pointer;
`;
export const Footer = styled.div`
  width: 100%;
  height: 5%;
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  color: #fcf8fe;
  padding: 4px;
  font-weight: 25px;
  @media only screen and (max-width: 760px) {
    font-size: 10px;
  }
`;

export const Name = styled.span`
  width: 90%;
  margin-bottom: 15px;
  padding-left: 2px;

  @media only screen and (max-width: 760px) {
    padding-right: 0;
  }
`;

export const Price = styled.span`
  width: 10%;
  padding-right: 15px;
`;
